import { render } from "./manage-dashboard-extra-info.vue?vue&type=template&id=b33c73d2"
import script from "./manage-dashboard-extra-info.vue?vue&type=script&lang=js"
export * from "./manage-dashboard-extra-info.vue?vue&type=script&lang=js"
script.render = render

export default script